import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const CompanyField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.Organization} field={FIELD_NAMES.COMPANY} optional={optional} />;
};

CompanyField.propTypes = {
  optional: PropTypes.bool,
};
